import { rj, useRj, useRunRj } from "react-rocketjump"
import rjList, {
  nextPreviousPaginationAdapter,
} from "react-rocketjump/plugins/list"
import rjDebounce from "react-rocketjump/plugins/debounce"
import api from "../api"

const interactionListRj = rj(
  rjDebounce(),
  rjList({
    pageSize: 100,
    pagination: nextPreviousPaginationAdapter,
  }),
  {
    name: "interactions",
    effectCaller: rj.configured(),
    effect: (wpAuth) => (params = {}) =>
      api.auth(wpAuth).get(`/api/crm/interaction`, params),
    mutations: {
      create: rj.mutation.single({
        effect: (wpAuth) => (data) => {
          return api.auth(wpAuth).post(`/api/crm/interaction`, data)
        },
        updater: (state, result) => {
          if (state?.data?.list) {
            return {
              ...state,
              data: {
                ...state.data,
                list: [...state.data.list, result],
              },
            }
          } else {
            return state
          }
        },
      }),
      update: rj.mutation.single({
        effect: (wpAuth) => (id, data) => {
          return api.auth(wpAuth).patch(`/api/crm/interaction/${id}`, data)
        },
        updater: (state, result) => {
          return {
            ...state,
            data: {
              ...state.data,
              list: state.data.list.map((item) =>
                item.id !== result.it ? item : result
              ),
            },
          }
        },
      }),
      remove: rj.mutation.single({
        effect: (wpAuth) => (itemId) => {
          return api
            .auth(wpAuth)
            .mapResponse(() => itemId)
            .delete(`/api/crm/interaction/${itemId}`)
        },
        updater: (state, result) => {
          if (state?.data?.list) {
            return {
              ...state,
              data: {
                ...state.data,
                list: state.data.list.filter((item) => item.id !== result) ,
              },
            }
          } else {
            return state
          }
        },
      }),
    },
    computed: {
      interactions: "getList",
      count: "getCount",
      loading: "isPending",
      error: "getError",
      pageCount: "getNumPages",
      hasNext: "hasNext",
      hasPrev: "hasPrev",
    },
  }
)

export function useInteractions(params) {
  return useRunRj(interactionListRj, [params], false)
}

function useInteractionsControlled() {
  return useRj(interactionListRj)
}

useInteractions.controlled = useInteractionsControlled

const interactionRj = rj({
  name: "interaction",
  effectCaller: rj.configured(),
  effect: (wpAuth) => (id) =>
    api.auth(wpAuth).get(`/api/crm/interaction/${id}`),
  mutations: {
    update: rj.mutation.single({
      effect: (wpAuth) => (id, data) => {
        return api.auth(wpAuth).patch(`/api/crm/interaction/${id}`, data)
      },
      updater: "updateData",
    }),
  },
  computed: {
    interaction: "getData",
    loading: "isPending",
    error: "getError",
  },
})

export function useInteraction(id) {
  return useRunRj(interactionRj, [id], true)
}

const interactionHistoryRj = rj({
  name: "interaction",
  effectCaller: rj.configured(),
  effect: (wpAuth) => (id) =>
    api.auth(wpAuth).get(`/api/crm/interaction/${id}/history`),
  computed: {
    interactionHistory: "getData",
    loading: "isPending",
    error: "getError",
  },
})

export function useInteractionHistory(id) {
  return useRunRj(interactionHistoryRj, [id], true)
}
